;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import type { CurrentUser } from '@qogita/canary-client'
import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import { useQuery } from '@tanstack/react-query'
import { createContext, useContext, useEffect, useState } from 'react'
import { getUserQueries } from 'src/deprecated/api/user-queries'
import { useRefreshSession } from 'src/deprecated/hooks/api/usePostAuthRefresh'
import { getIsValidPortalUser } from 'src/deprecated/utils/getIsValidPortalUser'
import { isQogitaUserEmail } from 'src/deprecated/utils/isQogitaUserEmail'
import { identifyUser } from 'src/deprecated/utils/report/tracking'

import { useLogout } from './Authentication'

type ClientUser = CurrentUser & { isQogitaUser: boolean }

type UserContext = ClientUser | null

const UserContext = createContext<UserContext>(null)

export const UserProvider = (props: { children: React.ReactNode }) => {
  const canaryClient = useCanaryClient()
  const userQueries = getUserQueries(canaryClient)
  const logout = useLogout()
  const [user, setUser] = useState<UserContext | null>(null)
  const refreshSessionQuery = useRefreshSession()

  const { data, error, fetchStatus } = useQuery({
    ...userQueries.detail(),
    enabled: Boolean(refreshSessionQuery?.data?.accessToken),
  })

  useEffect(() => {
    // Only set the user to null if network is idle and stale data available
    // oxlint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix this genuine linter error if you are working on this code.
    if (!data && fetchStatus === 'idle') setUser(null)
  }, [fetchStatus, data])

  useEffect(() => {
    if (data) {
      const isQogitaUser = isQogitaUserEmail(data.email)

      if (getIsValidPortalUser(data)) {
        // oxlint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix this genuine linter error if you are working on this code.
        setUser({
          ...data,
          isQogitaUser,
        })
      } else {
        logout()
      }
    }
  }, [data, logout])

  useEffect(() => {
    if (user?.qid) {
      identifyUser(user)
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.qid])

  useEffect(() => {
    if (error) logout()
  }, [error, logout])

  return <UserContext.Provider {...props} value={user} />
}

export const useUserContext = (): UserContext => {
  return useContext(UserContext)
}

export const useUser = () => {
  const user = useContext(UserContext)

  if (!user) {
    throw new Error(
      'useUser must be called only when UserProvider has an User.',
    )
  }

  return user
}
